import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    access: state.access,
    refresh: state.refresh,
    user: state.user,
    dark: state.dark,
    drawer: state.drawer,
    paneSize: state.paneSize
    // Explicitly exclude: snackbar, socket, busy, key
  })
})

export default new Vuex.Store({
  state: {
    key: 0,
    access: null,
    refresh: null,
    user: null,
    busy: false,
    drawer: false,
    dark: false,
    snackbar: {
      visible: false,
      text: null,
      color: null
    },
    socket: {
      isConnected: false,
      progress: {},
      update: null,
      reconnectError: false,
    },
    paneSize: [ { "min": 25, "max": 75, "size": 50 }, { "min": 25, "max": 75, "size": 50 } ] 
  },
  getters: {
    isBusy: state => {
      return state.busy
    },
    user: state => {
      return state.user
    },
    isDark: state => {
      return state.dark
    },
    socket: state => {
      return state.socket
    },
    snackbar: state => {
      return state.snackbar
    },
    online: state => {
      return state.socket.isConnected
    },
    paneSize: state => {
      return state.paneSize
    }
  },
  mutations: {
    authLogin (state, payload) {
      state.access = payload.access
      state.refresh = payload.refresh
    },
    authRefresh(state, payload) {
      state.access = payload
    },
    setRefreshToken(state, payload) {
      state.refresh = payload
    },
    authLogout (state) {
      state.access = null
      state.refresh = null
      state.user = null
    },
    setDark(state, payload) {
      state.dark = payload
    },
    setUser(state, payload) {
      state.user = payload.user
    },
    setUserSession(state, payload) {
      state.user.session = payload
    },
    refresh(state) {
      state.key += 1
    },
    setBusy(state, payload=true) {
      state.busy = payload
    },
    toggleDrawer(state) {
      state.drawer = !state.drawer
    },
    setPaneSize(state, payload) {
      state.paneSize = payload
    },
    // 
    // Socket connection management
    // 
    connectSocket(state) {
      if (state.user && !state.socket.isConnected) {
        // This will be handled by the main.js WebSocket initialization
      }
    },
    disconnectSocket(state) {
      state.socket.isConnected = false
      state.socket.progress = {}
    },
    // 
    // Snackbar events
    // 
    showSnackbar(state, payload) {
      state.snackbar.text = payload.text
      state.snackbar.color = payload.color
      state.snackbar.visible = true
    },
    closeSnackbar(state) {
      state.snackbar.visible = false
      state.snackbar.text = null
      state.snackbar.color = null
    },
    // 
    // Socket related methods
    // 
    SOCKET_ONOPEN (state, event)  {
      state.socket.isConnected = true
      state.socket.reconnectError = false
    },
    SOCKET_ONCLOSE (state, event)  {
      state.socket.isConnected = false
    },
    SOCKET_ONERROR (state, event)  {
      state.socket.isConnected = false
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE (state, notification)  {
      if (notification.type == 'message') {
        state.snackbar.text = notification.value.message
        state.snackbar.color = notification.value.color
        state.snackbar.visible = true
        this.commit('refresh')
      } else if (notification.type == 'update') {
        state.socket.update = notification.value.message
      } else if (notification.type == 'progress') {
        state.socket.progress = notification.value
      } else if (notification.type == 'download') {
        const buffer = notification.value
        var blob = new Blob(["\ufeff", buffer])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', `${notification.value.uuid} - Complete.csv`)
        document.body.appendChild(link)
        link.click()
        // state.key += 1
      }
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      state.socket.reconnectError = false
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true
    },
    removeProgress(state, uuid) {
      delete state.socket.progress[uuid]
    }
  },
  actions: {
    // WebSocket connection management
    async ensureSocketConnection({ state, commit }) {
      if (state.user && !state.socket.isConnected) {
        commit('connectSocket')
        
        // Wait a bit and check if connection was successful
        setTimeout(() => {
          if (!state.socket.isConnected) {
            // Could implement retry logic here
          }
        }, 2000)
      }
    },
    
    async reconnectSocket({ state, dispatch }) {
      if (state.user && !state.socket.isConnected) {
        await dispatch('ensureSocketConnection')
      }
    }
  },
  plugins: [vuexLocal.plugin],
})
